import { FrameRange } from 'content-creation-common/models';
import Frame from '../Frame';

import { isNumber } from '../../util/numbers';

export default class ShotGroupMeta {
  _active;
  _chapterIndex;
  _duration;
  _elementId;
  _frameEnd;
  _frameMarker;
  _frameStart;
  _loading;
  _selected;
  _shotIndex;
  _shotSkipped;
  _thumbnailUrl;

  constructor(
    elementId,
    frameMarker,
    frameStart,
    frameEnd,
    shotIndex,
    active = false,
    loading = false,
    selected = false,
    thumbnailUrl = null,
    chapterIndex = null,
    shotSkipped = false,
  ) {
    this._active = active;
    this._elementId = elementId;
    this._frameEnd = frameEnd;
    this._frameMarker = frameMarker;
    this._frameStart = frameStart;
    this._loading = loading;
    this._selected = selected;
    this._shotIndex = shotIndex;
    this._thumbnailUrl = thumbnailUrl;
    this._chapterIndex = chapterIndex;
    this._shotSkipped = shotSkipped;

    if (isNumber(frameStart) && isNumber(frameEnd)) {
      const frameRange = new FrameRange(frameStart, frameEnd);
      this._duration = Frame.frameToSeconds(frameRange.length);
    }
  }

  get active() {
    return this._active;
  }

  get chapterIndex() {
    return this._chapterIndex;
  }

  get duration() {
    return this._duration;
  }

  get elementId() {
    return this._elementId;
  }

  get frameEnd() {
    return this._frameEnd;
  }

  get frameMarker() {
    return this._frameMarker;
  }

  get frameStart() {
    return this._frameStart;
  }

  get index() {
    return this._shotIndex;
  }

  get loading() {
    return this._loading;
  }

  get selected() {
    return this._selected;
  }

  get thumbnailUrl() {
    return this._thumbnailUrl;
  }

  get shotSkipped() {
    return this._shotSkipped;
  }

  /**
   * Checks if object is an instance of ShotGroupMeta
   *
   * @param inputObject
   * @returns {boolean}
   */
  static isShotGroupMeta(inputObject) {
    return inputObject instanceof ShotGroupMeta;
  }
}
